"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectAnswer = exports.rawMarkup = exports.checkAnswer = void 0;
var _snarkdown = _interopRequireDefault(require("snarkdown"));
var _dompurify = _interopRequireDefault(require("dompurify"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var rawMarkup = exports.rawMarkup = function rawMarkup(data) {
  var sanitizer = _dompurify["default"].sanitize;
  return {
    __html: (0, _snarkdown["default"])(sanitizer(data))
  };
};
var checkAnswer = exports.checkAnswer = function checkAnswer(index, correctAnswer, answerSelectionType, _ref) {
  var userInput = _ref.userInput,
    userAttempt = _ref.userAttempt,
    currentQuestionIndex = _ref.currentQuestionIndex,
    continueTillCorrect = _ref.continueTillCorrect,
    showNextQuestionButton = _ref.showNextQuestionButton,
    incorrect = _ref.incorrect,
    correct = _ref.correct,
    setButtons = _ref.setButtons,
    setCorrectAnswer = _ref.setCorrectAnswer,
    setIncorrectAnswer = _ref.setIncorrectAnswer,
    setCorrect = _ref.setCorrect,
    setIncorrect = _ref.setIncorrect,
    setShowNextQuestionButton = _ref.setShowNextQuestionButton,
    setUserInput = _ref.setUserInput,
    setUserAttempt = _ref.setUserAttempt;
  var indexStr = "".concat(index);
  var disabledAll = {
    0: {
      disabled: true
    },
    1: {
      disabled: true
    },
    2: {
      disabled: true
    },
    3: {
      disabled: true
    }
  };
  var userInputCopy = _toConsumableArray(userInput);
  if (answerSelectionType === 'single') {
    if (userInputCopy[currentQuestionIndex] === undefined) {
      userInputCopy[currentQuestionIndex] = index;
    }
    if (indexStr === correctAnswer) {
      if (incorrect.indexOf(currentQuestionIndex) < 0 && correct.indexOf(currentQuestionIndex) < 0) {
        correct.push(currentQuestionIndex);
      }
      setButtons(function (prevState) {
        return _objectSpread(_objectSpread(_objectSpread({}, prevState), disabledAll), {}, _defineProperty({}, index - 1, {
          className: indexStr === correctAnswer ? 'correct' : 'incorrect'
        }));
      });
      setCorrectAnswer(true);
      setIncorrectAnswer(false);
      setCorrect(correct);
      setShowNextQuestionButton(true);
    } else {
      if (correct.indexOf(currentQuestionIndex) < 0 && incorrect.indexOf(currentQuestionIndex) < 0) {
        incorrect.push(currentQuestionIndex);
      }
      if (continueTillCorrect) {
        setButtons(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, index - 1, {
            disabled: !prevState[index - 1]
          }));
        });
      } else {
        setButtons(function (prevState) {
          return _objectSpread(_objectSpread(_objectSpread({}, prevState), disabledAll), {}, _defineProperty({}, index - 1, {
            className: indexStr === correctAnswer ? 'correct' : 'incorrect'
          }));
        });
        setShowNextQuestionButton(true);
      }
      setIncorrectAnswer(true);
      setCorrectAnswer(false);
      setIncorrect(incorrect);
    }
  } else {
    var maxNumberOfMultipleSelection = correctAnswer.length;
    if (userInputCopy[currentQuestionIndex] === undefined) {
      userInputCopy[currentQuestionIndex] = [];
    }
    if (userInputCopy[currentQuestionIndex].length < maxNumberOfMultipleSelection) {
      userInputCopy[currentQuestionIndex].push(index);
      if (correctAnswer.includes(index)) {
        if (userInputCopy[currentQuestionIndex].length <= maxNumberOfMultipleSelection) {
          setButtons(function (prevState) {
            return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, index - 1, {
              disabled: !prevState[index - 1],
              className: correctAnswer.includes(index) ? 'correct' : 'incorrect'
            }));
          });
        }
      } else if (userInputCopy[currentQuestionIndex].length <= maxNumberOfMultipleSelection) {
        setButtons(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, index - 1, {
            className: correctAnswer.includes(index) ? 'correct' : 'incorrect'
          }));
        });
      }
    }
    if (maxNumberOfMultipleSelection === userAttempt) {
      var cnt = 0;
      for (var i = 0; i < correctAnswer.length; i += 1) {
        if (userInputCopy[currentQuestionIndex].includes(correctAnswer[i])) {
          cnt += 1;
        }
      }
      if (cnt === maxNumberOfMultipleSelection) {
        correct.push(currentQuestionIndex);
        setCorrectAnswer(true);
        setIncorrectAnswer(false);
        setCorrect(correct);
        setShowNextQuestionButton(true);
        setUserAttempt(1);
      } else {
        incorrect.push(currentQuestionIndex);
        setIncorrectAnswer(true);
        setCorrectAnswer(false);
        setIncorrect(incorrect);
        setShowNextQuestionButton(true);
        setUserAttempt(1);
      }
    } else if (!showNextQuestionButton) {
      setUserAttempt(userAttempt + 1);
    }
  }
  setUserInput(userInputCopy);
};
var selectAnswer = exports.selectAnswer = function selectAnswer(index, correctAnswer, answerSelectionType, _ref2) {
  var userInput = _ref2.userInput,
    currentQuestionIndex = _ref2.currentQuestionIndex,
    setButtons = _ref2.setButtons,
    setShowNextQuestionButton = _ref2.setShowNextQuestionButton,
    incorrect = _ref2.incorrect,
    correct = _ref2.correct,
    setCorrect = _ref2.setCorrect,
    setIncorrect = _ref2.setIncorrect,
    setUserInput = _ref2.setUserInput;
  var selectedButtons = {
    0: {
      selected: false
    },
    1: {
      selected: false
    },
    2: {
      selected: false
    },
    3: {
      selected: false
    }
  };
  var userInputCopy = _toConsumableArray(userInput);
  if (answerSelectionType === 'single') {
    correctAnswer = Number(correctAnswer);
    userInputCopy[currentQuestionIndex] = index;
    if (index === correctAnswer) {
      if (correct.indexOf(currentQuestionIndex) < 0) {
        correct.push(currentQuestionIndex);
      }
      if (incorrect.indexOf(currentQuestionIndex) >= 0) {
        incorrect.splice(incorrect.indexOf(currentQuestionIndex), 1);
      }
    } else {
      if (incorrect.indexOf(currentQuestionIndex) < 0) {
        incorrect.push(currentQuestionIndex);
      }
      if (correct.indexOf(currentQuestionIndex) >= 0) {
        correct.splice(correct.indexOf(currentQuestionIndex), 1);
      }
    }
    setCorrect(correct);
    setIncorrect(incorrect);
    setButtons(function (prevState) {
      return _objectSpread(_objectSpread(_objectSpread({}, prevState), selectedButtons), {}, _defineProperty({}, index - 1, {
        className: 'selected'
      }));
    });
    setShowNextQuestionButton(true);
  } else {
    if (userInputCopy[currentQuestionIndex] === undefined) {
      userInputCopy[currentQuestionIndex] = [];
    }
    if (userInputCopy[currentQuestionIndex].includes(index)) {
      userInputCopy[currentQuestionIndex].splice(userInputCopy[currentQuestionIndex].indexOf(index), 1);
    } else {
      userInputCopy[currentQuestionIndex].push(index);
    }
    if (userInputCopy[currentQuestionIndex].length === correctAnswer.length) {
      var exactMatch = true;
      var _iterator = _createForOfIteratorHelper(userInput[currentQuestionIndex]),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var input = _step.value;
          if (!correctAnswer.includes(input)) {
            exactMatch = false;
            if (incorrect.indexOf(currentQuestionIndex) < 0) {
              incorrect.push(currentQuestionIndex);
            }
            if (correct.indexOf(currentQuestionIndex) >= 0) {
              correct.splice(correct.indexOf(currentQuestionIndex), 1);
            }
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (exactMatch) {
        if (correct.indexOf(currentQuestionIndex) < 0) {
          correct.push(currentQuestionIndex);
        }
        if (incorrect.indexOf(currentQuestionIndex) >= 0) {
          incorrect.splice(incorrect.indexOf(currentQuestionIndex), 1);
        }
      }
    } else {
      if (incorrect.indexOf(currentQuestionIndex) < 0) {
        incorrect.push(currentQuestionIndex);
      }
      if (correct.indexOf(currentQuestionIndex) >= 0) {
        correct.splice(correct.indexOf(currentQuestionIndex), 1);
      }
    }
    setCorrect(correct);
    setIncorrect(incorrect);
    setButtons(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, index - 1, {
        className: userInputCopy[currentQuestionIndex].includes(index) ? 'selected' : undefined
      }));
    });
    if (userInputCopy[currentQuestionIndex].length > 0) {
      setShowNextQuestionButton(true);
    }
  }
  setUserInput(userInputCopy);
};